import { FileReaderBase } from './file-reader-base';

export class JsonReaderProps extends FileReaderBase {
	constructor(init?: Partial<JsonReaderProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
